<template>
<div class="cst-survey-check-box">
    <svg id="check-box" :class="{selected: selected}" data-name="Checkbox default" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <path v-if="!selected" style="opacity: 0.54;" d="M20,4V20H4V4H20m0-2H4A2,2,0,0,0,2,4V20a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V4a2,2,0,0,0-2-2Z" transform="translate(-2 -2)"/>
        <rect v-if="selected" width="20" height="20" rx="2" ry="2"/>
        <path v-if="selected" style="fill: #fff;" d="M19,9.94a.845.845,0,0,0,0-1.18L17.8,7.58a.845.845,0,0,0-1.18,0l-5.68,5.7L8.38,10.72a.845.845,0,0,0-1.18,0L6.02,11.9a.845.845,0,0,0,0,1.18l4.32,4.34a.845.845,0,0,0,1.18,0l1.18-1.18,6.28-6.3Z" transform="translate(-2 -2)"/>
    </svg>
</div>
</template>

<script>
   export default {
     props: ['moduleId', 'selectedModules'],
     computed: {
       selected: function () {
         return this.selectedModules.indexOf(parseInt(this.moduleId)) !== -1
       }
     }
   }
</script>

<style lang="less" scoped>
    @import '../_theme';
    #check-box {
        fill: @text-color;
    }
    #check-box.selected {
        fill: @main-button-color;
    }
    .cst-survey-check-box {
        display: inline-block;
    }
</style>


// WEBPACK FOOTER //
// src/components/CheckBox.vue